// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type MetadataProperties = {
  user_environment?: 'dev' | 'prod' | 'qa';
  validated_url?: string;
  system_locale?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/metadata/jsonschema/1-0-8';
export const metadataName = 'metadata';
export class Metadata extends BaseTrackingContext<MetadataProperties> {
  constructor(properties: MetadataProperties) {
    super(metadataName, schema, properties);
  }
}
